import BossModel from "@/models/BossModel";
import Agent from '@/models/Agent/Agent'
import Product from "@/models/Agent/Product/Product";
import Currency from "@/models/Currency/Currency";
import AgentCurrency from "@/models/Agent/Code/Currency/Currency";

export default class Code extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'agent/code';

    /**
     *
     * @type {string}
     */
    static entity = 'agentCodes';

    static fields() {
		return {
			id: this.number(null).nullable(),
			agent_id: this.number(null).nullable(),
			default_currency_id: this.number(null).nullable(),
			name: this.attr(null),
			is_active: this.boolean(null),
            agent: this.belongsTo(Agent, 'agent_id'),
            defaultCurrency: this.hasOne(Currency, 'default_currency_id'),
            currencies: this.hasMany(AgentCurrency,'agent_code_id'),
            products: this.hasMany(Product, 'agent_code_id'),
		}
	}

    /**
     *
     * @param params
     * @returns {*}
     */
    static search (params = {}) {
        return this.api()
            .filtered(params.filters)
            .with(['agent.country'])
            .get(true).then((data) => {
            let agentCodes = [];
            for (let key in data) {
                if (data[key].id !== undefined) {
                    agentCodes.push(new Code(data[key]));
                }
            }

            return agentCodes;
        });
    }

    /**
     *
     * @returns {boolean|*}
     */
    Agent() {
        return this.getRelated('agent');
    }

}
